import "animate.css";
import { Col, Row } from "antd";
import React, { useEffect, useState } from "react";

import CardInfo from "components/CardInfo";
import LoadingSpin from "components/Loading";
import ScrollUpBtn from "components/ScrollUpBtn";

import { academicYears, getPagePayload, resolveAcademicYear } from "years";

import requestEmail from "assets/images/png/Pic-01.png";
import requestLearning from "assets/images/png/Pic-02.png";
import library from "assets/images/png/Pic-03.png";
import sports from "assets/images/png/Pic-04.png";
import medical from "assets/images/png/Pic-05.png";
import scholarship from "assets/images/png/Pic-06.png";
import dormitory from "assets/images/png/Pic-07.png";

import { CardContainer, Container, Href, Title } from "./courseInfo.style";

const CourseInfo = ({ year }) => {
  const [dataCourse, setDataCourse] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const currentAcademicYear =
    academicYears.find(({ ce }) => ce === resolveAcademicYear(year)) ||
    academicYears[0];

  useEffect(() => {
    window.scrollTo(0, 0);

    getDataCourse();
  }, [year]);

  const getDataCourse = () => {
    setIsLoading(false);
    const response = { data: getPagePayload(year, "course") };

    if (response?.data?.code === 200) {
      const data = response?.data?.data;
      setIsLoading(true);
      setDataCourse(data?.course);
    } else {
      setIsLoading(true);
      setDataCourse([]);
    }
  };

  const listImage = {
    "department-science": requestEmail,
    "department-social": requestLearning,
    "department-agricultural": library,
    "department-engineering": sports,
    "department-medicine": medical,
    "department-nursing": scholarship,
    "department-dentistry": dormitory,
    "department-public-health": requestEmail,
    "department-degitech": library,
  };

  return (
    <>
      <Container>
        <Row>
          <Col span={24}>
            <Title className="animate__animated animate__flipInX animate__slow">
              แนะนำหลักสูตร {currentAcademicYear.be}
            </Title>
          </Col>
        </Row>
        {isLoading ? (
          <CardContainer>
            {dataCourse.length >= 0 &&
              dataCourse.map((item, index) => {
                return (
                  <Href
                    to={
                      item?.link && item?.link != null && item?.link != ""
                        ? item?.link
                        : item?.slang
                    }
                    key={index}
                    rel="noreferrer"
                    target={
                      item?.link && item?.link != null && item?.link != ""
                        ? "_blank"
                        : "_self"
                    }
                  >
                    <CardInfo
                      src={item?.image ? item?.image : listImage[item?.slang]}
                      nameImage={item?.nameEN}
                      name={item?.nameTH}
                      cursor="true"
                    />
                  </Href>
                );
              })}
          </CardContainer>
        ) : (
          <LoadingSpin />
        )}
      </Container>
      <ScrollUpBtn />
    </>
  );
};

export default CourseInfo;
